// Store of the app
import Vue from 'vue';
import Vuex from 'vuex';

// Modules
import application from './modules/application';
import auth from './modules/auth';
import certificate from './modules/certificate';
import fileTypes from './modules/file-types';
import organizations from './modules/organizations';
import signatory from './modules/signatory';
import signworkflows from './modules/parapheurs';
import templates from './modules/templates';
import settingsUsers from './modules/settings-users';
import settingsGroups from './modules/settings-groups';
import ui from './modules/ui';
require('es6-promise').polyfill();

Vue.use(Vuex);

export default new Vuex.Store({

  modules: {
    application,
    auth,
    certificate,
    fileTypes,
    organizations,
    signatory,
    signworkflows,
    templates,
    settingsUsers,
    settingsGroups,
    ui,
  },

  strict: process.env.NODE_ENV !== 'production',
});



// WEBPACK FOOTER //
// ./src/store/index.js